'use client';

import { RollingBrandLogos } from '@/components/BrandLogos/RollingBrandLogos';

/** Figma 6385:3418 — full-width inline auto-scrolling logo marquee, no tagline */
export const HomeBrandLogos = () => (
  <RollingBrandLogos showHeading={false} />
);

export default HomeBrandLogos;
